import { useMemo } from 'react';

import { Label } from '../Label/Label';
import { getAssetLabels } from '../Splash/AssetSplash/getAssetLabels';

import type { FC } from 'react';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import * as styles from './AssetMetadata.module.scss';

type Props = {
  asset: SvpAssetAdditional;
};

const AssetMetadata: FC<Props> = ({ asset }) => {
  const labels = useMemo(() => getAssetLabels(asset), [asset]);

  return (
    <div className={styles.metadata}>
      <Label labels={labels} />
    </div>
  );
};

export { AssetMetadata };
